/**
 * @generated SignedSource<<8a56663b30fd4af152a2750e1e44d91b>>
 * @relayHash 5161a116bba83e52eeb1c6fddec9127c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dedb3a1250667c1c2118d6b697219d110f60811022404d80b9d408cc783d8de8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isJscInlineEditFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-inline-edit-fast-follows-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import shouldFetchAppUserTypeForComments_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-issue-view-comments.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';
import simplifiedTimeTracking_provider from '@atlassian/jira-relay-provider/src/simplified-time-tracking.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "dedb3a1250667c1c2118d6b697219d110f60811022404d80b9d408cc783d8de8",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarissueviewcommentsrelayprovider": shouldFetchAppUserTypeForComments_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": simplifiedTimeTracking_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider
    }
  }
};

export default node;
